module.exports = __webpack_public_path__ + "static/media/room-changes.86d539b2.svg";